<script lang="ts" setup>
  import { computed } from 'vue';
  import { mpfTagDefaults, MpfTagProps } from './MpfTag.props';
  import './MpfTag.scss';

  const props = withDefaults(defineProps<MpfTagProps>(), mpfTagDefaults);

  defineOptions({
    name: 'MpfTag',
  });

  const tagClasses = computed(() => [
    'mpf-tag',
    `mpf-tag--${props.colour}`,
  ]);
</script>

<template v-if="props.text">
  <div :class="tagClasses">{{ props.text }}</div>
</template>
